// import { IDocumentBody } from '../../services/api/requests/addLegalDocument';
// import { ICreateCombo } from '../../services/api/requests/createComboPlan';
// import { ICoupon } from '../../services/api/requests/createCoupon';
// import { IAdmin } from '../../services/api/requests/getAdminList';
// import { IAdminRoles } from '../../services/api/requests/getAdminRoles';
// import { IProductComboItem } from '../../services/api/requests/getComboProducts';
// import { IConversionTemplate } from '../../services/api/requests/getConversionTemplatesList';
// import { ICountry, ICountryGroup } from '../../services/api/requests/getCountries';
// import { INormalizedCouponUsageRuleSet } from '../../services/api/requests/getCouponUsageRules';
// import { INormalizedPayout } from '../../services/api/requests/getCustomerPayoutList';
// import { IGateway } from '../../services/api/requests/getGatewayList';
// import { IGetInstance } from '../../services/api/requests/getInstances';
// import { IPaymentMethod } from '../../services/api/requests/getPaymentMethodList';
// import { IProductListItem } from '../../services/api/requests/getProductList';
// import { IPlan } from '../../services/api/requests/getProductPlans';
// import { IProduct } from '../../services/api/requests/getProducts';
// import { INormalizedPurchaseRuleSet } from '../../services/api/requests/getPurchaseRules';
// import { IService } from '../../services/api/requests/getServices';
// import { ISetting } from '../../services/api/requests/getSettingsList';
// import { UserDetails } from '../../services/api/requests/getUserDetails';
// import { IPayoutAdminRequestListItem } from '../../services/api/requests/massPayouts';
// import { IPermission, IPermissionGroup } from '../../services/api/requests/permissions';

// TODO: fix types
import {IDataResponse} from '../../services/api/requests/getAudioList';

export interface EntitiesState {
  readonly allData: IDataResponse
  // readonly permissions: IPermission[];
  // readonly permissionGroups: IPermissionGroup[];
  // readonly roles: IAdminRoles[] | null;
  // readonly userForEditing: IAdmin | null;
  // readonly couponForEditing: ICoupon | null;
  // readonly instanceForEditing: IGetInstance | null;
  // readonly gatewayForEditing: IGateway | null;
  // readonly settingForEditing: ISetting | null;
  // readonly conversionTemplateForEditing: IConversionTemplate | null;
  // readonly paymentMethodForEditing: IPaymentMethod | null;
  // readonly planForEditing: { plans: IPlan[]; editPlanId: number | null } | null;
  // readonly instances: IGetInstance[] | [];
  // readonly countries: ICountry[] | [];
  // readonly productForEditing: IProductListItem | null;
  // readonly comboForEditing: IProductComboItem | null;
  // readonly comboPlanForEditing: ICreateCombo | null;
  // readonly payoutDetails: INormalizedPayout | null;
  // readonly services: IService[] | [];
  // readonly paymentMethods: IPaymentMethod[] | null;
  // readonly payoutRequestDetails: IPayoutAdminRequestListItem[] | null;
  // readonly legalDocumentForEditing: IDocumentBody | null;
  // readonly purchaseRules: INormalizedPurchaseRuleSet[] | [];
  // readonly couponUsageRules: INormalizedCouponUsageRuleSet[] | [];
  // readonly countryGroups: ICountryGroup[] | null;
  // readonly userDetails: UserDetails | null;
}

export const ActionTypes = {
  SAVE_ALL_DATA: 'SAVE_ALL_DATA',
  PLAY_AUDIO_TRACK: 'PLAY_AUDIO_TRACK',
}

export interface PlayAudioAction {
  type: typeof ActionTypes.PLAY_AUDIO_TRACK;
  payload: number;
}
